import React, { useState } from 'react';

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleAccordionToggle = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  const accordionData = [
    {
      id: 'one',
      title: 'What is CoinCraze?',
      content: 'CoinCraze is a meme-inspired cryptocurrency that combines fun and innovation, designed for a vibrant community of crypto enthusiasts.',
    },
    {
      id: 'two',
      title: 'How do I purchase CoinCraze?',
      content: 'CoinCraze is a meme-inspired cryptocurrency that combines fun and innovation, designed for a vibrant community of crypto enthusiasts.',
    },
    {
      id: 'three',
      title: 'Is CoinCraze secure?',
      content: 'CoinCraze is a meme-inspired cryptocurrency that combines fun and innovation, designed for a vibrant community of crypto enthusiasts.',
    },
    {
      id: 'four',
      title: 'What is the total supply of CoinCraze?',
      content: 'CoinCraze is a meme-inspired cryptocurrency that combines fun and innovation, designed for a vibrant community of crypto enthusiasts.',
    },
    {
      id: 'five',
      title: 'How can I stay updated?',
      content: 'CoinCraze is a meme-inspired cryptocurrency that combines fun and innovation, designed for a vibrant community of crypto enthusiasts.',
    },
  ];

  return (
    <div className="accordion accordion-flush" id="rts-accordion">
      {accordionData.map((item, index) => (
        <div className="accordion-item" key={item.id}>
          <div className="inner">
            <div className="accordion-header" id={item.id}>
              <h4
                className={`accordion-button ${activeIndex === index ? 'collapse show' : 'collapsed'}`}
                onClick={() => handleAccordionToggle(index)}
                aria-expanded={activeIndex === index ? 'true' : 'false'}
                aria-controls={`item__${item.id}`}
              >
                {item.title}
              </h4>
            </div>
            <div
              id={`item__${item.id}`}
              className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}
              aria-labelledby={item.id}
              data-bs-parent="#rts-accordion"
            >
              <div className="accordion-body">
                {item.content}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
